import axios from 'axios';
import authHeader from './auth-header';

const StatsService = {
  async getOverview() {
    try {
      const response = await axios.get('/admin/dashboard-stats', {
        headers: authHeader()
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stats overview:", error);
      throw error;
    }
  }
};

export default StatsService;
